import React, { useState, useEffect } from 'react';
import { OnScrollWrapper } from '../UtilityWrappers';
import CountUp from 'react-countup';
export const AnimatedValue = ({ value }) => {
    const [isVisible, setIsVisible] = useState(false);
    // handle visibility when component unmounts
    useEffect(() => {
        return () => setIsVisible(false);
    }, []);
    return (React.createElement(OnScrollWrapper, { onVisibilityChange: setIsVisible, intervalDelay: 500 },
        React.createElement(CountUp, { end: isVisible ? Number(value) : 0, duration: 1.5, redraw: true })));
};
